<template>
  <div class="w-full">
    <!-- Category pill -->
    <Button
      id="mobile-filter"
      type="button"
      theme="DARK"
      size="md"
      class="w-full flex h-[3.5714rem] items-center justify-center px-4 py-3 rounded-md border text-left transition-colors"
      :class="[
        isActive ? 'bg-gray-100 border-gray-400' : 'bg-white border-gray-300',
        selectedCount ? 'bg-gray-100' : ''
      ]"
      :aria-label="`Open ${filterKey} filter`"
      :title="`Open ${filterKey} filter`"
      @click.stop="$emit('open', filterKey)"
    >
        <span class="font-normal text-md text-ash-500">
        <!-- Sort By -->
        <template v-if="isSortBy">
          {{ title }}
        </template>

        <!-- Other filters -->
        <template v-else>
          <template v-if="selectedCount">
            +{{ selectedCount }} {{ title }}
          </template>
          <template v-else>
            Any {{ title }}
          </template>
        </template>
      </span>

      <!-- Chevron ONLY for Sort By -->
      <Icon
        v-if="isSortBy"
        icon="chevron-down"
        class="transition-transform"
        :class="{ 'rotate-180': isActive }"
      />
    </Button>

    <!-- Expanded dropdown -->
    <div v-if="isActive" class="mt-2">
      <MobileMultiDropdownFilter
        :title="title"
        :options="options"
        :selected-values="selectedValues"
        :filter-key="filterKey"
        :is-open="isActive"
        :is-sort-by="isSortBy"
        @select="onSelect"
        @close="$emit('open', null)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '../../atom/icon.vue'
import MobileMultiDropdownFilter from '../../organism/product/mobileMultiDropdownFilter.vue'
import Button from '../../atom/button.vue'

const props = defineProps<{
  title: string
  filterKey: string
  options: string[]
  selectedValues: string[]
  isActive: boolean
  selectedCount: number
  isSortBy: boolean
}>()

const emit = defineEmits<{
  (e: 'open', key: string | null): void
  (e: 'select', payload: { filterKey: string; value: string }): void
}>()

const onSelect = (payload: { key: string; value: string }) => {
  emit('select', { filterKey: payload.key, value: payload.value })
}
</script>
